import { render, staticRenderFns } from "./reservationOrderDetail.vue?vue&type=template&id=330cb19c&scoped=true"
import script from "./reservationOrderDetail.vue?vue&type=script&lang=js"
export * from "./reservationOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./reservationOrderDetail.vue?vue&type=style&index=0&id=330cb19c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330cb19c",
  null
  
)

export default component.exports